/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useState, useEffect } from 'react';
import { APP_TOKEN } from '../constants';

export const authContext = React.createContext({});

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({ loading: true, data: null });

  const setAuthData = (data) => {
    console.log('🟢 setAuthData called with:', data);
    setAuth({ data });
  };

  useEffect(() => {
    const storedData = JSON.parse(window.localStorage.getItem(APP_TOKEN));
    // console.log("📦 Data fetched from localStorage:", storedData);
    setAuth({
      loading: false,
      data: storedData,
    });

    const handlePermissionsUpdated = (event) => {
      if (event?.detail) {
        setAuth({ loading: false, data: event.detail });
      } else {
        const refreshed = JSON.parse(window.localStorage.getItem(APP_TOKEN));
        if (refreshed) {
          setAuth({ loading: false, data: refreshed });
        }
      }
    };

    window.addEventListener('auth:permissions-updated', handlePermissionsUpdated);
    window.addEventListener('storage', handlePermissionsUpdated);

    return () => {
      window.removeEventListener('auth:permissions-updated', handlePermissionsUpdated);
      window.removeEventListener('storage', handlePermissionsUpdated);
    };
  }, []);
  // Mount hone par localStorage se data fetch karte hain

  useEffect(() => {
    if (!auth.loading) {
      // console.log("💾 Saving auth.data to localStorage:", auth.data);
      window.localStorage.setItem(APP_TOKEN, JSON.stringify(auth.data));
    }
  }, [auth.data, auth.loading]);
  // Jab auth.data ya loading change ho to localStorage update hota hai

  useEffect(() => {
    // console.log("🔄 Current auth state:", auth);
  }, [auth]);
  // Debugging: auth state me koi bhi change hote hi print hoga

  return (
    <authContext.Provider value={{ auth, setAuthData }}>
      {children}
    </authContext.Provider>
  );
};

export default AuthProvider;
